export const idlFactory = ({ IDL }) => {
  const WithdrawArgs = IDL.Record({
    to: IDL.Principal,
    from_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat,
  })
  const BlockIndex = IDL.Nat
  const RejectionCode = IDL.Variant({
    NoError: IDL.Null,
    CanisterError: IDL.Null,
    SysTransient: IDL.Null,
    DestinationInvalid: IDL.Null,
    Unknown: IDL.Null,
    SysFatal: IDL.Null,
    CanisterReject: IDL.Null,
  })
  const WithdrawError = IDL.Variant({
    FailedToWithdraw: IDL.Record({
      rejection_code: RejectionCode,
      fee_block: IDL.Opt(IDL.Nat),
      rejection_reason: IDL.Text,
    }),
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat,
    }),
    TemporarilyUnavailable: IDL.Null,
    Duplicate: IDL.Record({ duplicate_of: IDL.Nat }),
    BadFee: IDL.Record({ expected_fee: IDL.Nat }),
    InvalidReceiver: IDL.Record({ receiver: IDL.Principal }),
    CreatedInFuture: IDL.Record({ ledger_time: IDL.Nat64 }),
    TooOld: IDL.Null,
    InsufficientFunds: IDL.Record({ balance: IDL.Nat }),
  })
  const Account = IDL.Record({
    owner: IDL.Principal,
    subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
  })
  const WithdrawFromArgs = IDL.Record({
    to: IDL.Principal,
    spender_subaccount: IDL.Opt(IDL.Vec(IDL.Nat8)),
    from: Account,
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: IDL.Nat,
  })
  const WithdrawFromError = IDL.Variant({
    GenericError: IDL.Record({
      message: IDL.Text,
      error_code: IDL.Nat,
    }),
    TemporarilyUnavailable: IDL.Null,
    InsufficientAllowance: IDL.Record({ allowance: IDL.Nat }),
    Duplicate: IDL.Record({ duplicate_of: BlockIndex }),
    InvalidReceiver: IDL.Record({ receiver: IDL.Principal }),
    CreatedInFuture: IDL.Record({ ledger_time: IDL.Nat64 }),
    TooOld: IDL.Null,
    FailedToWithdrawFrom: IDL.Record({
      withdraw_from_block: IDL.Opt(IDL.Nat),
      rejection_code: RejectionCode,
      refund_block: IDL.Opt(IDL.Nat),
      approval_refund_block: IDL.Opt(IDL.Nat),
      rejection_reason: IDL.Text,
    }),
    InsufficientFunds: IDL.Record({ balance: IDL.Nat }),
  })
  return IDL.Service({
    withdraw: IDL.Func([WithdrawArgs], [IDL.Variant({ Ok: BlockIndex, Err: WithdrawError })], []),
    withdraw_from: IDL.Func(
      [WithdrawFromArgs],
      [IDL.Variant({ Ok: BlockIndex, Err: WithdrawFromError })],
      []
    ),
  })
}
export const init = ({ IDL }) => {
  return []
}
